// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum ChargeRefundationStatus {
  Valid = "VALID",
  Refunded = "REFUNDED",
  RefundedToDistributor = "REFUNDED_TO_DISTRIBUTOR",
  PartiallyRefunded = "PARTIALLY_REFUNDED",
}
export default ChargeRefundationStatus;
